/*
 * <cart-gift-note> — saves a customer's gift message + "include sender name"
 * choice to the cart as cart attributes ("Gift note" and "Include sender name"),
 * which show on the order in admin. Live-saves so it survives cart re-renders;
 * also submits with cart-form as a no-JS fallback. Defined once; connectedCallback
 * re-binds after every re-render.
 */
if (!customElements.get('cart-gift-note')) {
  customElements.define(
    'cart-gift-note',
    class CartGiftNote extends HTMLElement {
      connectedCallback() {
        const textarea = this.querySelector('textarea');
        const sender = this.querySelector('.cart-gift-note__sender-input');
        if (!textarea || textarea.dataset.giftBound === '1') return;
        textarea.dataset.giftBound = '1';

        const post = (attributes) => {
          const root =
            (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes }),
          }).catch(() => {});
        };

        let timer;
        const saveNote = () => post({ 'Gift note': textarea.value });
        textarea.addEventListener('input', () => {
          clearTimeout(timer);
          timer = setTimeout(saveNote, 500);
        });
        textarea.addEventListener('change', () => {
          clearTimeout(timer);
          saveNote();
        });

        if (sender) {
          sender.addEventListener('change', () => {
            post({ 'Include sender name': sender.checked ? 'Yes' : '' });
          });
        }
      }
    }
  );
}
